// extracted by mini-css-extract-plugin
export default {"page":"help_page__rLZSr","goToLogin":"help_goToLogin__IAoDW","info":"help_info__i0OKV"};